import { ConstantInfo } from "../../core/constantInfo";

const TechSupportAiProcessing: React.FC = () => {
  return (
    <>
      <div className="p-2">
        <p className="text-center text-success text-xl font-extrabold px-2">AI Processing</p>
        <p className="text-center text-success text-xl font-extrabold px-2">Open 24/7</p>
        <p className="px-2 pt-2">
          WhatsApp:
          <a
            href={ConstantInfo.phone}
            className="cursor-pointer hover:text-primary transition duration-300 ease-in-out"
          >
            +372 5927 6691
          </a>
        </p>
      </div>
    </>
  );
};

export default TechSupportAiProcessing;
